import Vue from 'vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';

const unmaskedLength: number = 5;
const maskedLength: number = 7;

@Component({
    data() {
        return {
            date: null,
            length: 5,
            immediateValidation: false
        };
    },
    components: {
        ValidationProvider
    },
    inheritAttrs: false
})
export default class CardExpiration extends Vue {
    @Ref() readonly provider!: InstanceType<typeof ValidationProvider>;

    @Prop()
    value: string;

    @Prop()
    label: string;

    @Prop()
    placeholder: string;

    @Prop({ default: 'cardExpiration' })
    inputName: string;

    @Prop()
    validationMode: string;

    @Prop({ type: String, default: '#06A9BF' })
    checkColor: string;

    date;
    length: number;
    immediateValidation: boolean;

    created() {
        this.date = this.value;
    }

    unmasked(value: string) {
        return value?.replace(/ /g, '');
    }

    setMaxLength() {
        this.length = this.value?.length > 0
            ? maskedLength
            : unmaskedLength;
    }

    applyMaskedLength() {
        this.length = this.value?.length > 0
            ? maskedLength
            : unmaskedLength;
    }

    @Watch('date')
    change(value: string) {
        this.length = (value?.length === 0 || value?.length >= maskedLength)
            ? unmaskedLength
            : maskedLength;

        this.$emit('input', this.unmasked(value));
    }

    @Watch('value', { immediate: true })
    onChangeValue(value: string) {
        if (value) {
            this.immediateValidation = true;
        }
    }
}
